<template>
	<div class="my_push" v-loading="element_loading" element-loading-text="拼命加载中......"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div class="title">
			<div id="notice">
				<h5><br>
					<span>1、部门每月考勤模板:查看每个部门已经生成的考勤模板概况,默认查询当月。</span><br>
					<span>2、部门考勤模板:显示所选部门对应月份的考勤详情。并且双击对应日期可以修改。</span><br>
					<span>3、人员考勤模板:显示所有人员(可按部门筛选)对应月份的考勤详情。并且双击对应日期可以修改。</span><br>
					<span>4、可以通过导入Excel批量修改指定人员的出勤状态。设定范围通过第一步日期选择设置，默认当前月。</span><br>
					<span class="red">5、通过批量修改方式，导入完成后，需要重新计算考勤才能影响最终结果。</span><br>
				</h5>
			</div>
			模板生成菜单使用说明:<button @click="look_note">备注说明</button>
		</div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="部门每月考勤模板" name="first"></el-tab-pane>
			<el-tab-pane label="部门考勤模板" name="second"></el-tab-pane>
			<el-tab-pane label="人员考勤模板" name="third"></el-tab-pane>
			<!-- <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
		</el-tabs>
		<div v-show="show_push_one">
			<div class="content_edit">
				<div class="content_edit_item">
					<label>单号:</label>
					<input type="text" class="long1" v-model="sheet_no" placeholder="可以按单号或部门名称模糊查询"
						@keyup.enter="fun_load_first()" />

					<label>起始日期:</label>
					<el-date-picker v-model="s_date" type="date" class="long1" value-format="yyyy-MM-dd"
						placeholder="选择日期">
					</el-date-picker>

					<label>截止日期:</label>
					<el-date-picker v-model="e_date" type="date" class="long1" value-format="yyyy-MM-dd"
						placeholder="选择日期">
					</el-date-picker>

				</div>
				<div class="my_btn">
					<button @click="fun_load_first()">查询</button>
					<button @click="fun_todep_build('all')">全部建立</button>
				</div>
			</div>
			<table class="dataintable">
				<thead>
					<tr class="tab_header">
						<th>序号</th>
						<th class="long1_4">单号</th>
						<th class="short0">部门</th>
						<th class="short0">开始日期</th>
						<th class="short0">结束日期</th>
						<th class="short2">状态</th>
						<th class="short0">模板建立</th>
						<th class="short1">考勤模式</th>
						<th class="short0">上班时间</th>
						<th class="short0">下班时间</th>
						<th class="short0">备注</th>
						<th class="short0">录入人</th>
						<th class="long1_3">更新时间</th>
						<th class="long1">操作</th>
					</tr>
				</thead>
				<tbody class="tab_body">
					<tr :id="'f_'+item.row_num" v-for="(item, index) in list_first" :key="index"
						@click="fun_first_sel(item)">
						<td>{{ item.row_num }}</td>
						<td class="long1_4 left">{{ item.sheet_no }}</td>
						<td class="short0 cen">{{ item.d_name }}</td>
						<td class="short0 cen">{{ item.s_date }}</td>
						<td class="short0 cen">{{ item.e_date }}</td>
						<td class="short2 cen">{{ item.flag }}</td>
						<td class="short0 cen">{{ item.is_build }}</td>
						<td class="short1 cen">{{ item.record_type }}</td>
						<td class="short0 cen">{{ item.m_up_time }}</td>
						<td class="short0 cen">{{ item.a_down_time }}</td>
						<td class="short0 cen">{{ item.note }}</td>
						<td class="short0 cen">{{ item.u_name }}</td>
						<td class="long1_3 cen">{{ item.sys_date }}</td>
						<td class="long1 cen">
							<button class="btn_sub" @click="fun_todep_build('_build',item.id,item.sheet_no)">建立</button>
							<button class="btn_no" @click="fun_todep_build('_del',item.id,item.sheet_no)">删除</button>
						</td>
					</tr>
				</tbody>
			</table>


		</div>
		<div v-show="show_push_two">
			<div class="push-title">说明:<h5>1、显示所选数据对应月份的考勤详情。2、数据方式:编辑后回车</h5>
			</div>
			<div class="content_edit">
				<div class="content_edit_item">
					<span class="red">{{dep_name}}</span>
					<span>部门&nbsp;&nbsp;&nbsp;&nbsp;选择日期:<h5>{{select_day}}</h5></span>

				</div>
				<div class="my_btn">
					<button class="pre_btn_ok " @click="fun_to_user_build_all()">生成并确认所有部门所有人员考勤模板</button>
					<!-- <button class="pre_btn_ok " @click="fun_to_user_build()">生成指定部门:&nbsp;{{dep_name}} &nbsp;所有人员考勤模板</button> -->
					<!-- <button class="pre_btn_ok btn_can" @click="fun_to_user_deldep()">删除{{dep_name}}部门考勤模板</button> -->
					<button class="pre_btn_ok btn_can" @click="fun_to_user_deluser()">删除指定部门:&nbsp;{{dep_name}}
						&nbsp;所有人员考勤模板</button>
				</div>
			</div>
			<div id="second_title">
				<div class="third-left">
					<table class="dataintable">
						<thead>
							<tr class="tab_header">
								<th>序号</th>
								<th class="short0">部门</th>
								<th class="short9"><input type="checkbox" v-model="check_all" @click="fun_sel_all" />
								</th>
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr :id="'dep_'+item.row_num" v-for="(item, index) in list_first" :key="index"
								@click="fun_sel_deppartment(item)">
								<td>{{ item.row_num }}</td>
								<td class="short0 cen">{{ item.d_name }}</td>
								<td class="short9 cen"><input type="checkbox" v-model="item.sel"
										@change="fun_sel_dep_to_mode(item)" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="third-right">
					<div class="second-title">
						<span :style="{width:item_width+'px'}">星期一</span>
						<span :style="{width:item_width+'px'}">星期二</span>
						<span :style="{width:item_width+'px'}">星期三</span>
						<span :style="{width:item_width+'px'}">星期四</span>
						<span :style="{width:item_width+'px'}">星期五</span>
						<span :style="{width:item_width+'px'}">星期六</span>
						<span :style="{width:item_width+'px'}">星期日</span>
					</div>

					<div class="second-row" v-for="(item,index) in list_dep_all" :key="index">
						<span :id="'D_'+d.id" class="scond-item" :style="{width:item_width+'px'}" v-for="(d,id) in item"
							:key="id" @click="fun_sel_dep_today(d)" @dblclick="fun_sel_dep_day_toedit(d)"
							v-on:mousemove="show_detaildata($event, d)" v-on:mouseout="noshow_detaildata">
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">日期:</span><span class="right">
									{{d.work_date}}&nbsp;{{d.work_result}}</span>
							</div>
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">上班:</span>
								<el-time-picker class="right" :clearable=btn_clear v-model="d.m_up_time"
									format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点" readonly="readonly">
								</el-time-picker>
							</div>
							<!-- <div class="second-item-row" v-show="!d.fixed">
              <span class="left">早下:</span>
              <el-time-picker class="right" :clearable=btn_clear v-model="d.m_down_time" format="HH:mm:ss"
                :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点" readonly="readonly">
              </el-time-picker>
            </div>
            <div class="second-item-row" v-show="!d.fixed">
              <span class="left">下上:</span>
              <el-time-picker class="right" :clearable=btn_clear v-model="d.a_up_time" format="HH:mm:ss"
                :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点" readonly="readonly">
              </el-time-picker>
            </div> -->
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">下班:</span>
								<el-time-picker class="right" :clearable=btn_clear v-model="d.a_down_time"
									format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点" readonly="readonly">
								</el-time-picker>
							</div>
						</span>

					</div>

				</div>
			</div>
		</div>
		<div v-show="show_push_three">
			<div class="content_edit">
				<div class="content_edit_item">
					<label>选择部门:</label>
					<input type="text" class="short0" v-model="dep_name" />
					<pre-sel-one class="short0" @selectFunc="fun_list_del_sel($event)" v-bind:searchList="list_first"
						:selectValue="sel_list_val" />

				</div>
				<div class="my_btn">
					<button class="pre_btn_ok " @click="fun_set_alluser">确认{{dep_name}}部门所有人员考勤</button>
					<button class="pre_btn_ok " @click="fun_update_user('_sub')">确认{{dep_name}}部门{{dep_user}}考勤</button>
					<button class="pre_btn_ok "
						@click="fun_update_user_del('_del')">删除{{dep_name}}部门&nbsp;人员={{dep_user}}&nbsp;考勤模板</button>
					<button class="pre_btn_ok "
						@click="fun_update_user('_new')">重建{{dep_name}}部门&nbsp;人员={{dep_user}}&nbsp;考勤模板</button>
					<button @click="fun_Excel_up()">通过Excel导入批量修改出勤状态</button>
				</div>
			</div>
			<div id="third_content">
				<div class="third-left">
					<table class="dataintable">
						<thead>
							<tr class="tab_header">
								<th>序号</th>
								<th class="short0">用户</th>
								<th class="short9"><input type="checkbox" v-model="check_alluser"
										@click="fun_sel_alluser" /></th>
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr :id="'user_'+item.row_num" v-for="(item, index) in list_user" :key="index"
								@click="fun_sel_user(item)">
								<td>{{ item.row_num }}</td>
								<td class="short0 cen">{{ item.val }}</td>
								<td class="short9 cen"><input type="checkbox" v-model="item.sel" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="third-right">
					<div class="second-title">
						<span :style="{width:item_width+'px'}">星期一</span>
						<span :style="{width:item_width+'px'}">星期二</span>
						<span :style="{width:item_width+'px'}">星期三</span>
						<span :style="{width:item_width+'px'}">星期四</span>
						<span :style="{width:item_width+'px'}">星期五</span>
						<span :style="{width:item_width+'px'}">星期六</span>
						<span :style="{width:item_width+'px'}">星期日</span>
					</div>
					<div class="second-row" v-for="(item,index) in list_dep_user_all" :key="index">
						<span :id="'DU_'+d.id" class="scond-item" :style="{width:item_width+'px'}"
							v-for="(d,id) in item" :key="id" @click="fun_sel_dep_user_today(d)"
							@dblclick="fun_sel_dep_user_day_toedit(d)">
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">日期:</span><span class="right">
									{{d.work_date}}&nbsp;{{d.work_result}}</span>
							</div>
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">上班:</span>
								<el-time-picker class="right" :clearable=btn_clear v-model="d.m_up_time"
									format="HH:mm:ss" :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59'
                    }" placeholder="任意时间点" readonly="readonly">
								</el-time-picker>
							</div>
							<!-- <div class="second-item-row" v-show="!d.fixed">
                <span class="left">早下:</span>
                <el-time-picker class="right" :clearable=btn_clear v-model="d.m_down_time" format="HH:mm:ss"
                  :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59'
                    }" placeholder="任意时间点" readonly="readonly">
                </el-time-picker>
              </div>
              <div class="second-item-row" v-show="!d.fixed">
                <span class="left">下上:</span>
                <el-time-picker class="right" :clearable=btn_clear v-model="d.a_up_time" format="HH:mm:ss"
                  :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59'
                    }" placeholder="任意时间点" readonly="readonly">
                </el-time-picker>
              </div> -->
							<div class="second-item-row" v-show="!d.fixed">
								<span class="left">下班:</span>
								<el-time-picker class="right" :clearable=btn_clear v-model="d.a_down_time"
									format="HH:mm:ss" :picker-options="{
                      selectableRange: '00:00:00 - 23:59:59'
                    }" placeholder="任意时间点" readonly="readonly">
								</el-time-picker>
							</div>
						</span>

					</div>
				</div>
			</div>
		</div>

		<!-- 弹出待办业务单号 start -->
		<div class="top_sheetno" id="pre_detail_data" v-show="show_dep_day">
			<span class="top_sheetno_close">
				<img src="../../assets/image/schu.png" @click="closeshow" />
			</span>
			<div class="content_edit ">
				<span class="red">{{dep_name}}</span><span>部门&nbsp;&nbsp;&nbsp;&nbsp;选择日期:<h5>{{select_day}}</h5></span>

			</div>
			<div class="content_edit content-tan">
				<div class="tan-row">
					<label>上班:</label>
					<el-time-picker class="right" :clearable=btn_clear v-model="select_dep_day.m_up_time"
						format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
					</el-time-picker>
				</div>
				<!-- <div class="tan-row">
          <label>早上下班:</label>
          <el-time-picker class="right" :clearable=btn_clear v-model="select_dep_day.m_down_time" format="HH:mm:ss"
            :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
          </el-time-picker>
        </div>
        <div class="tan-row">
          <label>下午上班:</label>
          <el-time-picker class="right" :clearable=btn_clear v-model="select_dep_day.a_up_time" format="HH:mm:ss"
            :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
          </el-time-picker>
        </div> -->
				<div class="tan-row">
					<label>下班:</label>
					<el-time-picker class="right" :clearable=btn_clear v-model="select_dep_day.a_down_time"
						format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
					</el-time-picker>
				</div>
				<div class="tan-row">
					<label>考勤状态:</label>
					<input class="right short" type="text" v-model="select_dep_day.work_result" />
					<pre-sel-one class="short" @selectFunc="fun_list_sel($event,'1')" v-bind:searchList="list_rec_class"
						:selectValue="sel_rec_class" />
				</div>
				<div class="tan-row">
					<label>备注:</label>
					<input class="right " type="text" v-model="select_dep_day.note" @keyup.enter="fun_second('_upd')" />
				</div>
				<div class="content_btn_item">
					<button class="pre_btn_ok" @click="fun_second('_upd')">保存</button>
				</div>


			</div>
		</div>
		<!-- 弹出待办业务单号 end -->

		<!-- 弹出 部门人员 单号 start -->
		<div class="top_sheetno" id="pre_detail_data" v-show="show_dep_user_day">
			<span class="top_sheetno_close">
				<img src="../../assets/image/schu.png" @click="closeshow" />
			</span>
			<div class="content_edit ">
				<span class="red">{{dep_name}}</span><span>部门&nbsp;{{dep_user}}&nbsp;&nbsp;&nbsp;选择日期:<h5>{{select_day}}
					</h5>
				</span>

			</div>
			<div class="content_edit content-tan">
				<div class="tan-row">
					<label>上班:</label>
					<el-time-picker class="right" :clearable=btn_clear v-model="select_dep_user_day.m_up_time"
						format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
					</el-time-picker>
				</div>
				<!-- <div class="tan-row">
          <label>早上下班:</label>
          <el-time-picker class="right" :clearable=btn_clear v-model="select_dep_user_day.m_down_time" format="HH:mm:ss"
            :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
          </el-time-picker>
        </div>
        <div class="tan-row">
          <label>下午上班:</label>
          <el-time-picker class="right" :clearable=btn_clear v-model="select_dep_user_day.a_up_time" format="HH:mm:ss"
            :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
          </el-time-picker>
        </div> -->
				<div class="tan-row">
					<label>下班:</label>
					<el-time-picker class="right" :clearable=btn_clear v-model="select_dep_user_day.a_down_time"
						format="HH:mm:ss" :picker-options="{
                    selectableRange: '00:00:00 - 23:59:59'
                  }" placeholder="任意时间点">
					</el-time-picker>
				</div>
				<div class="tan-row">
					<label>考勤状态:</label>
					<input class="right short" type="text" v-model="select_dep_user_day.work_result" />
					<pre-sel-one class="short" @selectFunc="fun_list_sel($event,'2')" v-bind:searchList="list_rec_class"
						:selectValue="sel_rec_class" />
				</div>
				<div class="tan-row">
					<label>备注:</label>
					<input class="right " type="text" v-model="select_dep_user_day.note"
						@keyup.enter="fun_update_user('_upd')" />
				</div>
				<div class="content_btn_item">
					<button class="pre_btn_ok" @click="fun_update_user('_upd')">保存</button>
				</div>


			</div>
		</div>
		<!-- 弹出 部门人员 单号  end -->

		<!-- 通用导入excel -->
		<per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="parm_th" :api_url="'exp_record_upd'"
			:api_action="'record_upd'" :api_method="'longlong'" />

		<div id="pre_msg_data" style="display:none;"></div>
	</div>
</template>
<script>
	import api from '@/utils/type.js'
	import {
		GetShort,
		ChangeSpecial,
		BackSpecial
	} from '@/utils/localstore.js';
	import {
		Method_EasySelect,
		Method_Common,
		Method_DataByPage
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatToChina,
		dateFormatToChina2,
		dateFormatbyChina,
		daysFormMonth
	} from '@/utils/method.js'

	export default {
		components: {
			'pre-sel-one': () => import("../per_old/pre_select_one.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue")
		},
		data() {
			return {
				element_loading: false,
				activeName: 'first',
				show_note: false,

				show_push_one: true,
				show_push_two: false,
				show_push_three: false,

				list_first: [],
				f_rowid: '',
				sheet_no: '',
				dep_name: '',
				s_date: "",
				e_date: '',

				list_dep_all: [],
				select_day: '',
				select_dep_day: {},

				user_id: "",
				user_select: '',
				list_user: [],
				list_second: [],

				// 时间组件
				btn_clear: false,
				btn_read: true,

				// 弹窗组件
				show_dep_day: false,
				sel_c_id: 0,

				list_rec_class: [],
				sel_rec_class: {},

				dep_user: '',
				dep_user_id: 0,
				list_dep_user_all: [],
				select_user_day: '',
				select_dep_user_day: {},
				show_dep_user_day: false,

				item_width: 0,
				check_all: false,
				check_alluser: false,

				sel_list_dep: [],
				sel_list_val: {},

				// Excel上传
				parm_th: []
			};
		},
		created: function() {
			this.fun_load_first();
			this.chang_style();
			this.fun_load_class();
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			window.addEventListener('scroll', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
			// 这里只是操作dom
			window.addEventListener('resize', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
		},
		watch: {
			user_id(val) {
				if (Number(val) > 0) {
					this.fun_load_push();
				}
			}
		},
		methods: {
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			chang_style: function(t) {
				var that = this;
				this.$nextTick(function() {
					// var screenWidth = $(window).width();
					// var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
					// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
					var row_width = 0;
					if (t == '1') {
						row_width = $('#second_title').width();
						that.item_width = (row_width - 36 - 240) / 7;
					}
					if (t == '2') {
						row_width = $('#third_content').width();
						that.item_width = (row_width - 36 - 240) / 7;
					}

					// console.log('行宽=' + row_width);

				});
			},
			closeshow: function() {
				this.show_dep_day = false;
				this.show_dep_user_day = false;
			},
			handleClick(tab, event) {
				// console.log(tab, event);
				// console.log(tab.name);

				this.show_push_one = false;
				this.show_push_two = false;
				this.show_push_three = false;
				switch (tab.name) {
					case 'first':
						this.sheet_no = '';
						this.show_push_one = true;
						this.fun_load_first();
						break;
					case 'second':
						this.show_push_two = true;
						this.chang_style('1');
						// this.chang_style('2');
						if (typeof(this.sheet_no) !== 'undefined' && this.sheet_no != '') {
							this.fun_load_record_to_dep_all();
						}
						break;
					case 'third':
						this.show_push_three = true;
						this.check_alluser = false;
						this.fun_load_dep_user();
						this.chang_style('2');
						break;
					default:
						this.show_push_two = true;
						break;
				}

			},
			fun_load_first: function() {

				this.element_loading = true;
				this.list_first = [];
				this.$post(
					api.http_method, Method_EasySelect('data_exp_rec_dep', this.sheet_no, this.s_date, this.e_date)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;
						this.list_first = res.data.data;

						for (let i = 0; i < this.list_first.length; i++) {
							this.list_first[i].sel = false;
							this.list_first[i].val = this.list_first[i].d_name;
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}
				});

			},
			fun_todep_build: async function(type, id, temp_no) {
				// console.log('type=' + type + ' id=' + id + ' sheet_no' + temp_no);
				if (type == 'all') {
					for (let i = 0; i < this.list_first.length; i++) {
						id = 0, temp_no = '';
						id = this.list_first[i].id;
						temp_no = this.list_first[i].sheet_no;
						let d = [];
						d.push(temp_no);
						let res = await this.fun_dep_build('_build', id, d);
						if (res.status == 1) {
							this.$message({
								message: res.msg,
								type: 'success'
							});

						} else {
							this.$message({
								message: res.msg,
								type: 'warning'
							});
						}

					}
				} else {
					let d = [];
					d.push(temp_no);
					let res = await this.fun_dep_build(type, id, d);
					console.log(res);
					if (res.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}
				}

				if (type == '_del') {
					this.sheet_no = '';
				}

				this.fun_load_first();

			},
			fun_dep_build: function(type, t_rowid, d) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_Common('data_kq_todep_mode_' + type, t_rowid, '', d)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			fun_sel_deppartment: function(item) {
				// console.log(item);
				// console.log(this.select_dep_day);
				this.sheet_no = item.sheet_no;
				this.dep_name = item.d_name;
				// this.select_dep_day=
				for (var i = 0; i < this.list_first.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_first[i].row_num == item.row_num) {
						document.getElementById('dep_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_first[i].row_num % 2 == 0) {
							document.getElementById('dep_' + this.list_first[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('dep_' + this.list_first[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
			},
			fun_sel_dep_to_mode: function(item) {
				// console.log(item);
				this.sheet_no = item.sheet_no;
				for (var i = 0; i < this.list_first.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_first[i].sheet_no == item.sheet_no) {
						if (item.sel) {
							this.list_first[i].sel = true;
							this.fun_load_record_to_dep_all();
						} else {
							this.list_first[i].sel = false;
						}


					}
				}


			},
			fun_load_class: function() {

				this.element_loading = true;
				this.list_rec_class = [];
				this.$post(
					api.http_method, Method_EasySelect('data_exp_rec_class', '1')
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;
						this.list_rec_class = res.data.data;

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}
				});

			},
			fun_list_sel: function(id, type) {
				// console.log('id='+id);
				this.sel_c_id = 0;
				this.sel_c_id = id;
				if (type == '1') {
					this.select_dep_day.work_result = this.list_rec_class[id - 1].val;
				}
				if (type == '2') {
					this.select_dep_user_day.work_result = this.list_rec_class[id - 1].val;
				}

			},
			fun_first_sel: function(item) {
				// console.log(item);
				this.sheet_no = item.sheet_no;
				this.dep_name = item.d_name;

				for (var i = 0; i < this.list_first.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_first[i].row_num == item.row_num) {
						document.getElementById('f_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_first[i].row_num % 2 == 0) {
							document.getElementById('f_' + this.list_first[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('f_' + this.list_first[i].row_num).style.background = '#f5f5f5';
						}
					}
				}

			},
			fun_load_record_to_dep_all: function() {
				this.element_loading = true;
				this.list_dep_all = [];
				this.$post(
					api.http_method, Method_EasySelect('data_exp_rec_dep_all', this.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;

						let first_day = t[0].work_date;
						let y = '',
							m = '',
							d = '';
						y = first_day.substring(0, 4);
						m = first_day.substring(5, 7);
						d = first_day.substring(8, 10);
						console.log('年=' + y + ' 月=' + m + ' 日=' + d);
						// --"2021-02-26"
						let weekdate = new Date(first_day);
						let nweek = 0;
						nweek = weekdate.getDay();
						if (nweek == 0) {
							nweek = 7
						}
						console.log('星期=' + nweek);

						let old_list = [];

						// console.log('第一天是星期' + nweek);
						for (let i = 1; i < nweek; i++) {
							let o = {};
							o.id = 'before_' + i;
							o.fixed = true;
							o.show = false;
							old_list.push(o);
						}

						for (let i = 0; i < t.length; i++) {
							let o = {};
							o.id = t[i].id;
							o.row_num = t[i].row_num;
							o.sheet_no = t[i].sheet_no;
							o.work_date = t[i].work_date;
							o.work_result = t[i].work_result;
							o.d_name = t[i].d_name;
							o.m_up_time = dateFormatToChina(t[i].work_date, t[i].m_up_time);
							o.m_down_time = dateFormatToChina(t[i].work_date, t[i].m_down_time);
							o.a_up_time = dateFormatToChina(t[i].work_date, t[i].a_up_time);
							o.a_down_time = dateFormatToChina(t[i].work_date, t[i].a_down_time);
							o.note = t[i].note;
							o.flag = t[i].flag;
							o.u_name = t[i].u_name;
							o.sys_date = t[i].sys_date;
							o.fixed = false;
							o.show = false;
							old_list.push(o);
						}

						for (let i = 1; i < 7; i++) {
							let o = {};
							o.id = 'after_' + i;
							o.fixed = true;
							o.show = false;
							old_list.push(o);
						}
						let week_arr = [];
						let num = 0;

						for (var i = 0; i < old_list.length; i++) {
							if (num == 7) {
								num = 0;
							}
							if (num < 7) {
								week_arr.push(old_list[i]);
							}
							if (num == 6) {
								this.list_dep_all.push(week_arr);
								week_arr = [];
							}
							num++;
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}
				});


			},
			fun_sel_dep_today: function(d) {
				// 选择单天的部门模板
				// console.log(d);
				this.select_day = d.work_date

				this.select_dep_day = {};
				this.select_dep_day = d;

				for (var i = 0; i < this.list_dep_all.length; i++) {
					for (var j = 0; j < this.list_dep_all[i].length; j++) {
						// console.log(this.data_tab[i]);
						if (this.list_dep_all[i][j].id == d.id) {
							document.getElementById('D_' + d.id).style.background = '#92a4f3';
						} else {
							document.getElementById('D_' + this.list_dep_all[i][j].id).style.background = '#fff';
						}
					}

				}

			},
			fun_sel_dep_day_toedit: function(d) {
				if (!d.fixed) {
					this.show_dep_day = true;
				}
			},
			show_detaildata: function(that, item) {
				if (typeof(item.note) == 'undefined' || item.note == '') {
					return;
				}
				var x = 0,
					y = 0,
					temp_css = '';
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height();

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";

				temp_css += "max-width: 400px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

				let temp_innerHtml = '';
				temp_innerHtml = BackSpecial(item.note);
				temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>")

				document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
				document.getElementById("pre_msg_data").style.cssText = temp_css;

			},
			noshow_detaildata: function() {
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			fun_sel_all: function() {
				if (!this.check_all) {
					for (let i = 0; i < this.list_first.length; i++) {
						this.list_first[i].sel = true;
					}
				} else {
					for (let i = 0; i < this.list_first.length; i++) {
						this.list_first[i].sel = false;
					}
				}
			},
			fun_to_user_build_all: function() {
				if (this.list_first.length == 0) {
					this.$message({
						message: 'info',
						type: '请先勾选生成考勤的部门'
					});
					return;
				}

				// 生成所有部门所有人员考勤模板 并确认
				for (let i = 0; i < this.list_first.length; i++) {
					if (this.list_first[i].sel) {
						console.log(this.list_first[i]);
						let t = 1000;
						t = t * i;
						let that = this;
						setTimeout(() => {
							that.fun_buildover('_buildover', that.list_first[i]);
						}, t)
					}
				}
			},
			fun_buildover: function(type, item) {

				console.log('编辑部门', item);
				let row_id = 0;
				let sys_date = '',
					temp_no = '';
				let m_up = '',
					m_down = '';
				let a_up = '',
					a_down = '';
				let note = '';

				row_id = item.id;
				temp_no = item.sheet_no;
				sys_date = item.sys_date;
				note = item.note;

				m_up = dateFormatbyChina(item.m_up_time);
				m_down = dateFormatbyChina(item.m_down_time);
				a_up = dateFormatbyChina(item.a_up_time);
				a_down = dateFormatbyChina(item.a_down_time);

				m_up = m_up.substring(11, 20);
				m_down = m_down.substring(11, 20);
				a_up = a_up.substring(11, 20);
				a_down = a_down.substring(11, 20);
				console.log('[' + m_up + ']');
				console.log('[' + m_down + ']');
				console.log('[' + a_up + ']');
				console.log('[' + a_down + ']');
				if (typeof(this.sel_c_id) == 'undefined' || this.sel_c_id == 0) {
					for (let i = 0; i < this.list_rec_class.length; i++) {
						if (this.list_rec_class[i].val == item.work_result) {
							this.sel_c_id = this.list_rec_class[i].id;
							break;
						}
					}
				}

				let d = [];
				d.push(temp_no);
				d.push(this.sel_c_id);
				d.push(m_up);
				d.push(m_down);
				d.push(a_up);
				d.push(a_down);
				d.push(note);


				this.element_loading = true;

				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_Common('data_kq_dep_mode_' + type, row_id, sys_date, d, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: res.data.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}

				});


			},

			fun_to_user_build: function() {
				if (this.dep_name == '') {
					this.$message({
						type: 'info',
						message: '请先选择生成考勤的部门'
					});
					return;
				}

				this.fun_second('_build')
			},
			fun_to_user_deluser: function() {
				let title = '';
				title = '此操作将删除' + this.dep_name + '部门已经生成的人员考勤数据, 是否继续?';
				this.$confirm(title, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fun_second('_deldep');
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			fun_to_user_deldep: function() {
				let title = '';
				title = '此操作将删除' + this.dep_name + '部门考勤模板, 是否继续?';
				this.$confirm(title, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fun_second('_deldep');
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			fun_second: function(type) {
				if (typeof(this.select_dep_day) === 'undefined' || this.select_dep_day == '') {
					this.$message({
						message: '请选择要修改的数据',
						type: 'warning'
					});
					return;
				}

				console.log(this.select_dep_day);
				let row_id = 0;
				let sys_date = '';
				let m_up = '',
					m_down = '';
				let a_up = '',
					a_down = '';
				let note = '';

				row_id = this.select_dep_day.id;
				sys_date = this.select_dep_day.sys_date;
				note = this.select_dep_day.note;

				m_up = dateFormatbyChina(this.select_dep_day.m_up_time);
				m_down = dateFormatbyChina(this.select_dep_day.m_down_time);
				a_up = dateFormatbyChina(this.select_dep_day.a_up_time);
				a_down = dateFormatbyChina(this.select_dep_day.a_down_time);

				m_up = m_up.substring(11, 20);
				m_down = m_down.substring(11, 20);
				a_up = a_up.substring(11, 20);
				a_down = a_down.substring(11, 20);
				// console.log('['+m_up+']');
				// console.log('['+m_down+']');
				// console.log('['+a_up+']');
				// console.log('['+a_down+']');
				if (typeof(this.sel_c_id) == 'undefined' || this.sel_c_id == 0) {
					for (let i = 0; i < this.list_rec_class.length; i++) {
						if (this.list_rec_class[i].val == this.select_dep_day.work_result) {
							this.sel_c_id = this.list_rec_class[i].id;
							break;
						}
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.sel_c_id);
				d.push(m_up);
				d.push(m_down);
				d.push(a_up);
				d.push(a_down);
				d.push(note);

				this.element_loading = true;

				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_Common('data_kq_dep_mode_' + type, row_id, sys_date, d, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: res.data.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}

				});


			},
			fun_load_dep_user: function() {
				this.sel_list_dep = [];



				// 计算当前选择部门单号对应的所有人员
				this.element_loading = true;
				this.list_user = [];
				this.$post(
					api.http_method, Method_EasySelect('data_exp_dep_user', this.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;
						this.list_user = res.data.data;
						for (let i = 0; i < this.list_user.length; i++) {
							this.list_user[i].sel = false;
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}
				});


			},
			fun_sel_user: function(item) {
				// console.log(item);
				// console.log(this.list_user);
				this.dep_user = item.val;
				this.dep_user_id = item.id;
				for (var i = 0; i < this.list_user.length; i++) {
					// console.log(this.data_tab[i]);
					if (this.list_user[i].row_num == item.row_num) {
						document.getElementById('user_' + item.row_num).style.background = '#92a4f3';
					} else {
						if (this.list_user[i].row_num % 2 == 0) {
							document.getElementById('user_' + this.list_user[i].row_num).style.background = '#fff';
						} else {
							document.getElementById('user_' + this.list_user[i].row_num).style.background = '#f5f5f5';
						}
					}
				}

				this.fun_load_dep_user_all();
			},
			fun_load_dep_user_all: function() {
				this.element_loading = true;
				this.list_dep_user_all = [];
				this.$post(
					api.http_method, Method_DataByPage('data_exp_kq_dep_user', 1, this.sheet_no, this.dep_user_id)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						let t = res.data.data;

						let first_day = t[0].work_date;
						// let y = '',
						//   m = '',
						//   d = '';
						// y = first_day.substring(0, 4);
						// m = first_day.substring(5, 7);
						// d = first_day.substring(8, 10);
						// console.log('年=' + y + ' 月=' + m + ' 日=' + d);
						// --"2021-02-26"
						let weekdate = new Date(first_day);
						let nweek = 0;
						nweek = weekdate.getDay();
						if (nweek == 0) {
							nweek = 7
						}

						let old_list = [];

						// console.log('第一天是星期' + nweek);
						for (let i = 1; i < nweek; i++) {
							let o = {};
							o.id = 'before_' + i;
							o.fixed = true;
							o.show = false;
							old_list.push(o);
						}

						for (let i = 0; i < t.length; i++) {
							let o = {};
							o.id = t[i].id;
							o.row_num = t[i].row_num;
							o.sheet_no = t[i].sheet_no;
							o.work_date = t[i].work_date;
							o.work_result = t[i].work_result;
							o.d_name = t[i].d_name;
							o.m_up_time = dateFormatToChina2(t[i].m_up_time);
							o.m_down_time = dateFormatToChina2(t[i].m_down_time);
							o.a_up_time = dateFormatToChina2(t[i].a_up_time);
							o.a_down_time = dateFormatToChina2(t[i].a_down_time);
							o.note = t[i].note;
							o.flag = t[i].flag;
							o.u_name = t[i].u_name;
							o.sys_date = t[i].sys_date;
							o.fixed = false;
							o.show = false;
							old_list.push(o);
						}

						for (let i = 1; i < 7; i++) {
							let o = {};
							o.id = 'after_' + i;
							o.fixed = true;
							o.show = false;
							old_list.push(o);
						}
						let week_arr = [];
						let num = 0;

						for (var i = 0; i < old_list.length; i++) {
							if (num == 7) {
								num = 0;
							}
							if (num < 7) {
								week_arr.push(old_list[i]);
							}
							if (num == 6) {
								this.list_dep_user_all.push(week_arr);
								week_arr = [];
							}
							num++;
						}


					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}
				});
			},
			fun_sel_dep_user_today: function(d) {
				// 选择单天的部门模板
				// console.log(d);
				this.select_day = d.work_date

				this.select_dep_user_day = {};
				this.select_dep_user_day = d;

				for (var i = 0; i < this.list_dep_user_all.length; i++) {
					for (var j = 0; j < this.list_dep_user_all[i].length; j++) {
						// console.log(this.data_tab[i]);
						if (this.list_dep_user_all[i][j].id == d.id) {
							document.getElementById('DU_' + d.id).style.background = '#92a4f3';
						} else {
							document.getElementById('DU_' + this.list_dep_user_all[i][j].id).style.background = '#fff';
						}
					}

				}

			},
			fun_sel_dep_user_day_toedit: function(d) {
				if (!d.fixed) {
					this.show_dep_user_day = true;
				}
			},
			fun_update_user_del: function() {
				let title = '';
				title = '此操作将删除人员:' + this.dep_user + ' 考勤模板, 是否继续?';
				this.$confirm(title, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.fun_update_user('_del');
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			fun_set_alluser: function() {
				for (let i = 0; i < this.list_user.length; i++) {
					if (this.list_user[i].sel) {
						console.log(this.list_user[i]);

						let t = 1000;
						t = t * i;
						let that = this;

						let u_id = this.list_user[i].id;

						setTimeout(() => {
							let d = [];
							d.push(that.sheet_no);
							d.push(u_id);

							that.element_loading = true;

							let r = (Math.random() + '').substring(0, 8);
							that.$post(
								api.http_method, Method_Common('data_kq_dep_user_mode__sub', 0, '', d, r)
							).then(res => {
								that.element_loading = false;
								res = JSON.parse(res);
								console.log(res);
								if (res.data.status == 1) {

									that.$message({
										message: res.data.msg,
										type: 'success'
									});

								} else {
									that.$message({
										message: res.data.msg,
										type: 'warning'
									});

								}

							});
						}, t)
					}
				}
			},
			fun_update_user: function(type) {
				if (typeof(this.select_dep_user_day) == 'undefined' || this.select_dep_user_day == '') {
					this.$message({
						message: '请选择要修改的数据',
						type: 'warning'
					});
					return;
				}

				if (typeof(this.dep_user_id) == 'undefined' || this.dep_user_id == 0) {
					this.$message({
						message: '请先选择人员信息!',
						type: 'warning'
					});
					return;
				}

				console.log(this.select_dep_user_day);

				let row_id = 0;
				let sys_date = '';
				let m_up = '',
					m_down = '';
				let a_up = '',
					a_down = '';
				let note = '';

				row_id = this.select_dep_user_day.id;
				sys_date = this.select_dep_user_day.sys_date;
				note = this.select_dep_user_day.note;

				m_up = dateFormatbyChina(this.select_dep_user_day.m_up_time);
				m_down = dateFormatbyChina(this.select_dep_user_day.m_down_time);
				a_up = dateFormatbyChina(this.select_dep_user_day.a_up_time);
				a_down = dateFormatbyChina(this.select_dep_user_day.a_down_time);

				// m_up = m_up.substring(11, 20);
				// m_down = m_down.substring(11, 20);
				// a_up = a_up.substring(11, 20);
				// a_down = a_down.substring(11, 20);
				// console.log('[' + m_up + ']');
				// console.log('[' + m_down + ']');
				// console.log('[' + a_up + ']');
				// console.log('[' + a_down + ']');
				if (typeof(this.sel_c_id) == 'undefined' || this.sel_c_id == 0) {
					for (let i = 0; i < this.list_rec_class.length; i++) {
						if (this.list_rec_class[i].val == this.select_dep_day.work_result) {
							this.sel_c_id = this.list_rec_class[i].id;
							break;
						}
					}
				}

				let d = [];
				d.push(this.sheet_no);
				d.push(this.dep_user_id);
				d.push(this.sel_c_id);
				d.push(m_up);
				d.push(m_down);
				d.push(a_up);
				d.push(a_down);
				d.push(note);

				this.element_loading = true;

				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Method_Common('data_kq_dep_user_mode_' + type, row_id, sys_date, d, r)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: res.data.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});

					}

				});

			},
			fun_sel_alluser: function(item) {
				if (!this.check_alluser) {
					for (let i = 0; i < this.list_user.length; i++) {
						this.list_user[i].sel = true;
					}
				} else {
					for (let i = 0; i < this.list_user.length; i++) {
						this.list_user[i].sel = false;
					}
				}
			},
			fun_list_del_sel: function(e) {
				// console.log(e)
				let index = Number(e);
				for (let i = 0; i < this.list_first.length; i++) {
					if (this.list_first[i].id == index) {
						this.sheet_no = this.list_first[i].sheet_no;
						this.dep_name = this.list_first[i].val;
						this.fun_load_dep_user()
						break;
					}
				}
			},
			fun_Excel_up: function() {
				let days = 0,
					month = 0;
				var d = new Date();
				days = daysFormMonth(this.s_date);


				if (typeof(this.s_date) == 'undefined' || this.s_date == '') {
					month = d.getMonth() + 1;
				} else {
					month = Number(this.s_date.substring(5, 7));
				}

				console.log(this.s_date + '对应月份' + month + '天数=' + days);

				this.parm_th = [];
				let o_user = {};
				o_user.name = '姓名';
				o_user.key = 'u_name';
				o_user.val = '';
				o_user.p = '1';
				o_user.type = 'text';
				this.parm_th.push(o_user);

				o_user = {};
				o_user.name = '开始日期';
				o_user.key = 's_date';
				o_user.val = '';
				o_user.p = '1';
				o_user.type = 'date';
				this.parm_th.push(o_user);

				o_user = {};
				o_user.name = '结束日期';
				o_user.key = 'e_date';
				o_user.val = '';
				o_user.p = '1';
				o_user.type = 'date';
				this.parm_th.push(o_user);

				for (let i = 0; i < days; i++) {
					let o = {};
					o.name = month + '月' + (i + 1) + '号';
					o.key = 'th' + (i + 1);
					o.val = '';
					o.p = '1';
					o.type = 'text';
					this.parm_th.push(o);
				}


				let o_note = {};
				o_note.name = '备注';
				o_note.key = 'note';
				o_note.val = '';
				o_note.p = '1';
				o_note.type = 'text';
				this.parm_th.push(o_note);

				this.excelup();


			},
			refresh_data: function() {

			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},


		}
	};
</script>

<style scoped="scoped">
	.my_push {
		padding: 10px;
	}

	.my_btn {
		display: inline-block;
		vertical-align: sub;
		margin-left: 6px;
	}

	.my_btn>button {
		margin-left: 6px;
		margin-right: 6px;
	}

	.push-title {
		font-size: 20px;
		font-weight: 700;
		padding-bottom: 10px;
	}

	.push-table {
		max-height: 40vw;
		overflow: auto;
		padding-bottom: 10px;
		width: min-content;
	}

	.second-title {
		margin-top: 2px;
		padding: 2px 6px 2px 6px;
		/* min-width: 700px; */
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
		border: 1px solid #959595;
		margin: 1px;
	}


	.second-title>span {
		display: inline-block;
		vertical-align: middle;
		box-sizing: border-box;

		font-size: 14px;
		font-weight: 700;
		text-align: center;
		height: 24px;
		line-height: 22px;
		border: 1px solid #959595;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
	}

	.second-row {
		margin-top: 1px;
		padding: 2px 6px 2px 6px;
		min-width: 700px;
		text-align: center;
		color: #000000;
		font-size: 16px;
		font-weight: 500;
		/* border: 1px solid #959595; */

	}

	.second-row>span {
		display: inline-block;
		vertical-align: middle;
		box-sizing: border-box;

		font-size: 14px;
		font-weight: 700;
		text-align: center;

		height: 108px;
		border: 1px solid #959595;
		overflow: hidden;
		text-overflow: ellipsis;
		word-break: keep-all;
		margin: 2px;
	}

	.second-item-row {
		text-align: left;
		padding: 2px 1px;
	}

	.second-item-row>.left {
		font-weight: 500;
		width: 32px;
		height: 28px;
		line-height: 28px;
	}

	.second-item-row>.right {
		font-weight: 500;
		width: calc(100% - 42px);
		height: 28px;
		line-height: 28px;
	}



	.top_sheetno {
		position: fixed;
		top: 20%;
		left: 35%;
		background-color: rgba(0, 0, 0, 0.5);
		/* opacity: 0.2; */
		/* border: 1px solid black; */
		/* padding-left: 20px; */
		/* padding-right: 20px; */
		border-radius: 5px;
		z-index: 3;
		width: 30%;
		text-align: center;
		padding: 20px;
		overflow-x: auto;
	}

	.content-tan {
		padding: 10px 6px;
	}

	.top_sheetno_close>img {
		width: 24px;
		height: auto;
		position: absolute;
		right: 24px;
		top: 24px;
		cursor: pointer;
	}

	.tan-row {
		margin-top: 2px;
		padding: 2px 6px 2px 6px;
		text-align: left;
		margin-left: 10%;
	}

	.tan-row>label {
		text-align: right;
	}

	.tarn-row>button {
		text-align: right;
	}

	.third-left {
		display: inline-block;
	}

	.third-right {
		display: inline-block;
		vertical-align: top;
	}

	.short9 {
		min-width: 48px !important;
		width: 48px !important;
	}

	.content_edit_item label {
		margin-left: 10px;

	}
</style>